import { m, useReducedMotion } from 'framer-motion';

export default function Statement() {
  const shouldReduce = useReducedMotion();

  return (
    <section className="bg-ink py-28 sm:py-36 overflow-hidden relative">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none" aria-hidden="true">
        <svg
          viewBox="0 0 293.81 303.11"
          xmlns="http://www.w3.org/2000/svg"
          className="h-[82%] w-auto opacity-[0.05]"
        >
          <path d="M116.13,139.9l-26.91,46.6c-7.7,13.33-26.94,13.33-34.64,0L2.68,96.6c-3.57-6.19-3.57-13.81,0-20l13.45-23.3c3.57-6.19,10.18-10,17.32-10h26.91c7.15,0,13.75,3.81,17.32,10l38.45,66.6c3.57,6.19,3.57,13.81,0,20Z" fill="none" stroke="white" strokeWidth="2.5"/>
          <path d="M133.45,0h26.91c7.15,0,13.75,3.81,17.32,10l13.45,23.3c3.57,6.19,3.57,13.81,0,20l-13.45,23.3c-3.57,6.19,-10.18,10,-17.32,10h-26.91c-7.15,0,-13.75,-3.81,-17.32,-10l-13.45,-23.3c-3.57,-6.19,-3.57,-13.81,0,-20l13.45,-23.3C119.71,3.81,126.31,0,133.45,0Z" fill="none" stroke="white" strokeWidth="2.5"/>
          <path d="M291.13,96.6l-99.67,172.63c-.11.19-.22.39-.33.58l-13.45,23.3c-3.57,6.19-10.17,10-17.32,10h-26.9c-7.15,0-13.75-3.81-17.33-10l-13.45-23.3-13.45-23.3c-7.7-13.33,1.92-30,17.32-30h3.81c7.13,0,13.72-3.79,17.29-9.96.01-.01.02-.03.03-.04l1.91-3.3L216.13,53.3c3.58-6.18,10.18-10,17.33-10h26.9c7.15,0,13.75,3.82,17.32,10l13.45,23.3c3.58,6.19,3.58,13.82,0,20Z" fill="none" stroke="white" strokeWidth="2.5"/>
        </svg>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <m.p
          initial={shouldReduce ? false : { opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-ink-muted text-xs tracking-[0.2em] uppercase font-medium mb-10"
        >
          The Vehi difference
        </m.p>
        <m.h2
          initial={shouldReduce ? false : { opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: shouldReduce ? 0 : 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="text-white font-extrabold leading-[0.93] tracking-tight"
          style={{ fontSize: 'clamp(2.25rem, 5.5vw, 4.75rem)' }}
        >
          Software that works<br />
          <span className="text-accent">the way you work.</span>
        </m.h2>
      </div>
    </section>
  );
}
